import { useContext } from 'react';
import { MarketUiContext } from '~/app/market-config/market-ui-context';
import { CarConfiUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';

export function useMarketUiConfig() {
	const ctx = useContext<CarConfiUiConfiguration>(MarketUiContext);
	return ctx;
}
